module.exports = __webpack_public_path__ + "MemoryTwistLogo.png";